import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"plus\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.667 1.166a.5.5 0 10-1 0v4.5h-4.5a.5.5 0 100 1h4.5v4.167a.5.5 0 001 0V6.666h4.167a.5.5 0 000-1H6.667v-4.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol